<template>
  <div>
    <PaymentStatusInput
      v-model="innerValue" />
  </div>
</template>
<script>
import PaymentStatusInput from '@components/input/PaymentStatusInput';
import { mapMutations } from 'vuex';

export default {
  name: 'PaymentStatusInputFilter',
  components: {
    PaymentStatusInput
  },
  props: {
    value: {
      type: Number,
      required: true
    },
    field: {
      type: String,
      required: true
    }
  },
  computed: {
    innerValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
        this.setFilter({ key: this.field, value: val });
        if (val !== -1) {
          this.$emit('filter', () => (x) => x[this.field] === val);
        } else {
          this.$emit('filter', () => () => true);
        }
      }
    }
  },
  methods: {
    ...mapMutations({
      setFilter: 'dataTableFilters/setFilter'
    })
  },
  mounted() {
    this.innerValue = this.$store.state.dataTableFilters.filters[this.field] || this.value;
  }
};
</script>
<style>

</style>
